module.exports = __webpack_public_path__ + "static/media/hala.e11053e6.png";